import { Button } from "app/components/button";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Column } from "app/components/column";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { DigitalSignature } from "app/components/digital-signature";
import { Checkbox } from "app/components/checkbox";
import toast from "react-hot-toast";

const initialState = {
  files: null,
  signature: null,
  isChecked: false,
};

export function ArchivosAdjuntosForm() {
  const navigate = useNavigate();

  const { empresa, createSolicitud, isSubmitting } = useEmpresa();

  const [state, setState] = useState(initialState);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!empresa.establecimientos.length) {
        toast.error("Por favor, agregue al menos un establecimiento");

        return navigate("../establecimientos/add");
      }

      // if (!empresa.telefonos.length) {
      //   toast.error("Por favor, agregue al menos un número de telefono");

      //   return navigate("../contactos/telefonos/add");
      // }

      if (!empresa.celulares.length) {
        toast.error("Por favor, agregue al menos un número de celular");

        return navigate("../contactos/celulares/add");
      }

      if (!empresa.correos_electronicos.length) {
        toast.error(
          "Por favor, agregue al menos una dirección de correo electrónico"
        );

        return navigate("../contactos/correos-electronicos/add");
      }

      if (!empresa.encargados.length) {
        toast.error("Por favor, agregue al menos un encargado");

        return navigate("../encargados/add");
      }

      if (!empresa.actividades_economicas.length) {
        toast.error("Por favor, agregue al menos una actividad economica");

        return navigate("../actividad-economica/actividades-economicas/add");
      }

      if (!state.files) {
        throw new Error("¡Por favor, adjunte los archivos requeridos!");
      }

      if (!state.signature) {
        throw new Error("¡Por favor, firme dentro del cuadro en blanco!");
      }

      return await createSolicitud({
        files: [...state.files, state.signature],
      });
    } catch (error) {
      console.log(error);

      return toast.error(error.message);
    }
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader header="Archivos adjuntos (requerido)" />

        <fieldset disabled={createSolicitud.isLoading}>
          <CardBody>
            <Row>
              <Column>
                <div className="form-group">
                  <label className="form-label">
                    Seleccione los archivos adjuntos
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    multiple
                    onChange={(e) =>
                      setState((state) => ({
                        ...state,
                        files: e.target.files,
                      }))
                    }
                    accept="image/*, application/pdf"
                    required
                  />

                  <small className="form-text text-muted">
                    Por favor, adjunte copia de escritura de constitución, copia
                    de las identidades y RTN de los socios o encargados
                  </small>
                </div>
              </Column>

              <Column>
                <DigitalSignature
                  label="Firma del solicitante"
                  onWrite={(file) =>
                    setState((state) => ({
                      ...state,
                      signature: file,
                    }))
                  }
                />
              </Column>

              <Column>
                <Checkbox
                  label="El representante (persona natural, jurídica o representante legal) manifiesta que la información consignada en esta solicitud es fidedigna y se sujetará a las leyes, decretos y actos administrativos que reglamenta su uso."
                  checked={state.isChecked}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      isChecked: e.target.checked,
                    }))
                  }
                  required
                />
              </Column>
            </Row>
          </CardBody>

          <CardFooter>
            <DFlexResponsive justifyContent="end">
              <Button
                color="secondary"
                outline
                title="Anterior"
                onClick={() => navigate("../afiliacion")}
              />

              <Button
                type="submit"
                color="success"
                title="Enviar solicitud"
                disabled={!state.isChecked || !!isSubmitting}
              />
            </DFlexResponsive>
          </CardFooter>
        </fieldset>
      </form>
    </div>
  );
}
